var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#11121D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3158 16.2105V16.8947C23.3158 17.6474 22.7 18.2632 21.9474 18.2632H12.3684C11.6089 18.2632 11 17.6474 11 16.8947V7.31579C11 6.56316 11.6089 5.94737 12.3684 5.94737H21.9474C22.7 5.94737 23.3158 6.56316 23.3158 7.31579V8H17.1579C16.3984 8 15.7895 8.61579 15.7895 9.36843V14.8421C15.7895 15.5947 16.3984 16.2105 17.1579 16.2105H23.3158ZM17.1579 14.8421H24V9.36843H17.1579V14.8421ZM19.8947 13.1316C19.3268 13.1316 18.8684 12.6732 18.8684 12.1053C18.8684 11.5374 19.3268 11.079 19.8947 11.079C20.4626 11.079 20.9211 11.5374 20.9211 12.1053C20.9211 12.6732 20.4626 13.1316 19.8947 13.1316Z",
    fill: "#11121D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWallet);
export default __webpack_public_path__ + "static/media/mobileWallet.541b80b3.svg";
export { ForwardRef as ReactComponent };